import component from './treeCatalog.vue'

export default component
